"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_2 = require("swiper/react");
const swiper_1 = require("swiper");
require("swiper/css");
require("swiper/css/zoom");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ open, closeDialog, currentProductId, }) {
    var _a;
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog });
    (0, functions_1.useIOSDialogCloseScrollBack)(open);
    const products = (0, react_redux_1.useSelector)((state) => state.productData);
    const photoInfos = products.reduce((acc, item) => {
        if (item.images.length)
            acc.push({ id: item.id, name: item.name, imgUrl: item.images[0].img_url });
        return acc;
    }, []);
    const photosLength = photoInfos.length;
    const [photoIndex, setPhotoIndex] = (0, react_1.useState)(0);
    (0, react_1.useLayoutEffect)(() => {
        if (currentProductId) {
            setPhotoIndex(photoInfos.findIndex(photoInfos => photoInfos.id === currentProductId));
        }
    }, [currentProductId]);
    return ((0, jsx_runtime_1.jsxs)(PhotoDialog, Object.assign({ fullScreen: true, open: open, onClick: closeDialog }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: closeDialog }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: { width: '24px', height: '24px' } }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ onClick: e => e.stopPropagation() }, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, justifyContent: "center", pb: "12px", color: "white", position: "relative" }, { children: [(_a = photoInfos[photoIndex]) === null || _a === void 0 ? void 0 : _a.name, (0, jsx_runtime_1.jsx)("span", Object.assign({ id: "product_photo_index" }, { children: `${photoIndex + 1}/${photosLength}` }))] })), (0, jsx_runtime_1.jsx)(react_2.Swiper, Object.assign({ modules: [swiper_1.Zoom], initialSlide: photoIndex, onSlideChangeTransitionEnd: swiper => setPhotoIndex(swiper.activeIndex), onSlideResetTransitionStart: swiper => {
                            if (photoIndex === 0)
                                swiper.slideTo(photosLength - 1);
                            if (photoIndex === photosLength - 1)
                                swiper.slideTo(0);
                        }, threshold: 10, grabCursor: true, zoom: true, onZoomChange: (swiper, scale) => {
                            const photoIndexSpan = document.getElementById('product_photo_index');
                            const muiPaperDiv = document.querySelector('.MuiDialog-paper');
                            const prevSlide = document.querySelector('.swiper-slide-prev');
                            const nextSlide = document.querySelector('.swiper-slide-next');
                            if (scale !== 1) {
                                swiper.allowTouchMove = false;
                                if (photoIndexSpan)
                                    photoIndexSpan.style.display = 'none';
                                if (muiPaperDiv)
                                    muiPaperDiv.style.overflow = 'visible';
                                if (prevSlide)
                                    prevSlide.style.opacity = '0';
                                if (nextSlide)
                                    nextSlide.style.opacity = '0';
                            }
                            else {
                                swiper.allowTouchMove = true;
                                if (photoIndexSpan)
                                    photoIndexSpan.style.display = 'block';
                                if (muiPaperDiv)
                                    muiPaperDiv.style.overflow = 'hidden';
                                if (prevSlide)
                                    prevSlide.style.opacity = '1';
                                if (nextSlide)
                                    nextSlide.style.opacity = '1';
                            }
                        } }, { children: photoInfos.map((infos, idx) => ((0, jsx_runtime_1.jsx)(react_2.SwiperSlide, Object.assign({ zoom: true }, { children: (0, jsx_runtime_1.jsx)("img", { alt: infos.name, src: (0, functions_1.getCdnUrl)(infos.imgUrl), style: { maxHeight: Math.min(window.innerWidth, 600) } }) }), `dialog_slide_${infos.id}_${idx}`))) }))] }))] })));
}
exports.default = default_1;
const PhotoDialog = (0, styled_1.default)(Dialog_1.default) `
  .MuiIconButton-root {
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 2;
  }
  .MuiDialog-scrollPaper {
    background-color: black;
  }
  .MuiDialog-paper {
    justify-content: center;
    background-color: black;
    max-width: 800px;
    overflow: hidden;
  }
  #product_photo_index {
    position: absolute;
    bottom: -32px;
    right: 20px;
    padding: 4px 8px;
    border-radius: 100px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 12px;
    z-index: 2;
  }
  .swiper {
    width: 100%;
    overflow: visible;
  }
`;
